export default class ApplicationInstallCapabilityGrant {
    targetApplicationSlug: string;
    targetSchoolLinkId: string | null;
    capabilityKey: string;
    actions: string[] | null;

    constructor(grant: ApplicationInstallCapabilityGrant) {
        this.targetApplicationSlug = grant.targetApplicationSlug;
        this.targetSchoolLinkId = grant.targetSchoolLinkId;
        this.capabilityKey = grant.capabilityKey;
        this.actions = grant.actions;
    }

    static fromJson(json: any): ApplicationInstallCapabilityGrant {
        return new ApplicationInstallCapabilityGrant({
            targetApplicationSlug: json.targetApplicationSlug ?? '',
            targetSchoolLinkId: json.targetSchoolLinkId ?? null,
            capabilityKey: json.capabilityKey ?? '',
            actions: ApplicationInstallCapabilityGrant.parseActions(json.actionsJson),
        });
    }

    private static parseActions(actionsJson: string | null | undefined): string[] | null {
        if (!actionsJson) return null;
        try {
            const parsed = JSON.parse(actionsJson);
            return Array.isArray(parsed) ? parsed.filter((action): action is string => typeof action === 'string') : null;
        } catch {
            return null;
        }
    }
}
